<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="4">
        <v-card outlined>
          <v-card-title>
            {{ title }}
            <v-spacer />
            <v-chip v-if="items.length !== 0"
              color="#244EA2" dark
            >
              {{ items.length }}
            </v-chip>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-form ref="form">
              <v-autocomplete
                label="Município"
                v-model="params.municipio"
                :items="municipios"
                item-text="nome" item-value="codigo"
                clearable
                color="#244EA2"
                item-color="#244EA2"
              />
              <v-autocomplete label="Tipo de Pessoa"
                v-model="params.tipo_pessoa"
                :items="options.tipoPessoa"
                clearable dense multiple
                chips deletable-chips
                color="#244EA2"
                item-color="#244EA2"
              />
              <v-autocomplete label="Categoria"
                v-model="params.categoria"
                :items="options.categoria"
                item-text="descricao" item-value="codigo"
                clearable dense multiple
                chips deletable-chips
                color="#244EA2"
                item-color="#244EA2"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="removeLayer()">Limpar</v-btn>
            <v-btn color="#244EA2" dark
              :loading="loading"
              @click="addLayer()"
            >Pesquisar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="12">
        <v-card outlined>
          <v-card-title>
            {{ title }}
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              clearable
              single-line
              hide-details
              outlined dense
            ></v-text-field>
          </v-card-title>
          <v-divider />
          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            :search="search"
          >
            <template v-slot:item.tipoPessoa="{ item }">
              {{ item.tipoPessoa === 'F' ? 'Pessoa Física' : 'Pessoa Jurídica' }}
            </template>

            <template v-slot:item.categorias="{ item }">
              <v-chip-group>
                <v-chip
                  v-for="categoria in item.categorias"
                  :key="categoria.codigo"
                >
                  {{ categoria.descricao }}
                </v-chip>
              </v-chip-group>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import api from '@/api/vue-exemplo'
import { sisprofice } from '@/api/vue-exemplo'

export default {
  name: 'AgentesCulturais',
  data: () => ({
    title: 'Agentes Culturais',
    headers: [
      { text: 'Código', value: 'codigo', width: '10%' },
      { text: 'Nome', value: 'nome', width: '35%' },
      { text: 'Tipo Pessoa', value: 'tipoPessoa', width: '10%' },
      { text: 'Categorias', value: 'categorias', width: '45%' }
    ],
    items: [],
    loading: false,
    search: null,

    options: {
      categoria: [],
      tipoPessoa: [
        { text: 'Pessoa Física', value: 'F' },
        { text: 'Pessoa Jurídica', value: 'J' }
      ]
    },
    params: {
      municipio: null,
      tipo_pessoa: null,
      categoria: null
    }
  }),
  computed: {
    municipios () {
      return this.$store.getters.municipios
    }
  },
  mounted () {
    this.$store.dispatch('getMunicipios')
    this.getCategorias()
    // this.getAgentes()
    sisprofice.getPropostasMunicipio()
      .then(response => {
        this.data = response.data
        console.log(this.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    getAgentes () {
      this.loading = true
      api.getAgentes(this.params)
        .then(response => {
          this.items = response.data
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getCategorias () {
      api.getCategoriaAgente()
        .then(response => {
          this.options.categoria = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    removeLayer () {
      this.$refs.form.reset()
      this.addLayer()
    },
    addLayer () {
      this.getAgentes()
    }
  }
}
</script>
